/**
 * SpringAir Portable Kit JS
 * - Reveal-on-scroll: toggles .is-visible on [data-animate]
 * - Modal/popup: minimal open/close + ESC + click-outside
 */

function saInitReveal(root = document) {
  const nodes = Array.from(root.querySelectorAll('[data-animate]:not([data-sa-anim-bound])'));
  if (nodes.length === 0) return;

  nodes.forEach((n) => n.setAttribute('data-sa-anim-bound', '1'));

  if (!('IntersectionObserver' in window)) {
    nodes.forEach((n) => n.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
  );

  nodes.forEach((n) => io.observe(n));
}

function saInitModals(root = document) {
  const openers = Array.from(root.querySelectorAll('[data-sa-modal-open]'));
  openers.forEach((btn) => {
    if (btn.getAttribute('data-sa-modal-bound') === '1') return;
    btn.setAttribute('data-sa-modal-bound', '1');

    btn.addEventListener('click', () => {
      const modalId = btn.getAttribute('data-sa-modal-open');
      if (!modalId) return;
      saOpenModal(modalId, btn);
    });
  });
}

function saOpenModal(modalId, returnFocusEl) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const overlayId = modal.getAttribute('data-sa-overlay');
  const overlay = overlayId ? document.getElementById(overlayId) : null;

  modal.classList.add('is-open');
  overlay?.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');

  const closeButtons = modal.querySelectorAll('[data-sa-modal-close]');
  closeButtons.forEach((b) => (b.onclick = () => saCloseModal(modalId, returnFocusEl)));

  function onKeyDown(e) {
    if (e.key === 'Escape') {
      saCloseModal(modalId, returnFocusEl);
    }
  }

  function onOverlayClick(e) {
    if (e.target !== overlay) return;
    saCloseModal(modalId, returnFocusEl);
  }

  document.addEventListener('keydown', onKeyDown, { once: true });
  overlay?.addEventListener('click', onOverlayClick, { once: true });

  // focus first focusable control
  const focusTarget =
    modal.querySelector('input, select, textarea, button, a[href], [tabindex]:not([tabindex=\"-1\"])') || modal;
  focusTarget?.focus?.();
}

function saCloseModal(modalId, returnFocusEl) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const overlayId = modal.getAttribute('data-sa-overlay');
  const overlay = overlayId ? document.getElementById(overlayId) : null;

  modal.classList.remove('is-open');
  overlay?.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  returnFocusEl?.focus?.();
}

function saInitPortable(root = document) {
  saInitReveal(root);
  saInitModals(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => saInitPortable(document), { once: true });
} else {
  saInitPortable(document);
}

document.addEventListener('shopify:section:load', (event) => {
  if (!event?.target) return;
  saInitPortable(event.target);
});

// Expose small API for sections that need it
window.SpringAirPortable = {
  init: saInitPortable,
  openModal: saOpenModal,
  closeModal: saCloseModal
};

